import React, { createContext, useContext, useEffect, useState } from 'react';
import { useCustomSettings } from '../../hooks/use-custom-settings';
import { FooterLinkType } from '../api';

export type CustomSettingsContextType = {
  backgroundImgUrl: string | null,
  backgroundImgTitle: string,
  backgroundImgAltText: string,
  primaryColorHash: string | null,
  footerLinks: (FooterLinkType | void)[]
}

const useCustomSettingsProvider = () => {
  const { backgroundFile, primaryColor, backgroundTitle, backgroundAltText } = useCustomSettings();
  const [ backgroundImgUrl, setBackgroundImgUrl ] = useState<string | null>(backgroundFile);
  const [ backgroundImgTitle, setBackgroundTitle ] = useState<string>(backgroundTitle);
  const [ backgroundImgAltText, setBackgroundAltText ] = useState<string>(backgroundAltText ?? '');
  const [ primaryColorHash, setPrimaryColorHash ] = useState<string | null>(primaryColor);
  const [ footerLinks, setFooterLinks ] = useState<(FooterLinkType | void)[]>([]);

  useEffect(() => {
    setBackgroundImgUrl(backgroundFile);
    setPrimaryColorHash(primaryColor);
    setFooterLinks(footerLinks);
    setBackgroundTitle(backgroundTitle);
    setBackgroundAltText(backgroundAltText ?? '');
  }, [ backgroundFile, primaryColor, footerLinks, backgroundTitle, backgroundAltText ]);

  return { backgroundImgUrl, primaryColorHash, footerLinks, backgroundImgTitle, backgroundImgAltText };
};

const customSettingsContext = createContext<CustomSettingsContextType | void>(undefined);

type Props = { children: React.ReactNode | React.ReactNodeArray }
export const CustomSettingsProvider: React.FC<Props> = ({ children }: Props): JSX.Element => {
  const settings = useCustomSettingsProvider() as CustomSettingsContextType;

  return (
    <customSettingsContext.Provider value={settings}>
      {children}
    </customSettingsContext.Provider>
  );
};

export const useSettings = (): CustomSettingsContextType | void => useContext(customSettingsContext);

export default CustomSettingsProvider;
